export default "__VITE_ASSET__CUnNFfdg__"